__turbopack_context__.v({
  "features": "PlasmicHeaderMenuItem-module__6r9y0a__features",
  "featuresactive": "PlasmicHeaderMenuItem-module__6r9y0a__featuresactive",
  "svg": "PlasmicHeaderMenuItem-module__6r9y0a__svg",
  "text3": "PlasmicHeaderMenuItem-module__6r9y0a__text3",
  "text3active": "PlasmicHeaderMenuItem-module__6r9y0a__text3active",
});
